var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRework(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hourglass",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_2",
    "data-name": "\\uD0C0\\uC6D0 2",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1 1)",
    fill: "#ffc048"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_289",
    "data-name": "\\uADF8\\uB8F9 289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_196",
    "data-name": "\\uD328\\uC2A4 196",
    d: "M13.45,22.667h5.1L16,19.691Zm2.044-4.434-3.223,3.76A1.216,1.216,0,0,0,13.194,24h5.613a1.216,1.216,0,0,0,.923-2.007l-3.223-3.76a.666.666,0,0,0-1.012,0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_197",
    "data-name": "\\uD328\\uC2A4 197",
    d: "M20.026,11.4l1.774-1.9a.749.749,0,0,0,.2-.508V8.1a.747.747,0,0,0-.231-.537.835.835,0,0,0-.582-.233H10.814a.835.835,0,0,0-.582.233A.747.747,0,0,0,10,8.1v.884a.749.749,0,0,0,.2.508l1.65,1.778a3.708,3.708,0,0,1,3.774-.541,10.351,10.351,0,0,0,4.4.671Zm-1.258,1.357a13.323,13.323,0,0,1-3.52-.75,2.585,2.585,0,0,0-2.479.25l2.221,2.394a1.966,1.966,0,0,1,0,2.69L10.2,22.5a.749.749,0,0,0-.2.508V23.9a.747.747,0,0,0,.231.537.835.835,0,0,0,.582.233H21.186a.835.835,0,0,0,.582-.233A.747.747,0,0,0,22,23.9v-.884a.749.749,0,0,0-.2-.508l-4.788-5.16a1.966,1.966,0,0,1,0-2.69Zm-4.755,2.8a.64.64,0,0,1,0,.876L9.225,21.6a2.077,2.077,0,0,0-.558,1.414V23.9A2.081,2.081,0,0,0,9.3,25.391,2.171,2.171,0,0,0,10.814,26H21.186a2.171,2.171,0,0,0,1.511-.609,2.081,2.081,0,0,0,.636-1.494v-.884a2.077,2.077,0,0,0-.558-1.414l-4.788-5.16a.641.641,0,0,1,0-.877L22.775,10.4a2.077,2.077,0,0,0,.558-1.414V8.1A2.081,2.081,0,0,0,22.7,6.609,2.171,2.171,0,0,0,21.186,6H10.814A2.171,2.171,0,0,0,9.3,6.609,2.081,2.081,0,0,0,8.667,8.1v.884A2.077,2.077,0,0,0,9.225,10.4Z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRework);
export default __webpack_public_path__ + "static/media/rework.d36759cd1ac5d3392d6fd17da45910d3.svg";
export { ForwardRef as ReactComponent };